import type { ArticleType } from 'types';
import wpToArticleTransform, {
  type WpArticleResponse,
} from './wpToArticleTransform';

export type ArticlesDisplayMode = 'all' | 'curated';

interface WpArticlesSectionValues {
  title?: string;
  subTitle?: string;
  content?: string;
  variation?: string;
  background?: string;
  customCssClass?: string;
  displayMode?: ArticlesDisplayMode;
  postsPerPage?: number;
  articles?: WpArticleResponse[];
}

export default function wpToArticlesSectionTransform(
  acfValues: WpArticlesSectionValues
): {
  title: string;
  subTitle: string;
  content: string;
  variation: string;
  background: string;
  customCssClass: string;
  displayMode: ArticlesDisplayMode;
  postsPerPage: number;
  articles: ArticleType[];
} {
  return {
    title: acfValues.title || '',
    subTitle: acfValues.subTitle || '',
    content: acfValues.content || '',
    variation: acfValues.variation || '',
    background: acfValues.background || '',
    customCssClass: acfValues.customCssClass || '',
    displayMode: acfValues.displayMode || 'curated',
    postsPerPage: acfValues.postsPerPage || 8,
    articles: (acfValues.articles || []).map(wpToArticleTransform),
  };
}
